import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { API, Badge, de, dt, fehler } from "./shared";

const STATUS = { gueltig: ["gültig", "gruen"], laeuft_ab: ["läuft ab", "gelb"], abgelaufen: ["abgelaufen", "rot"], nicht_freigegeben: ["nicht freigegeben", "grau"] };

const Versionen = ({ code }) => {
  const [v, setV] = useState(null);
  useEffect(() => { axios.get(`${API}/dokumente/${code}/versionen`).then((r) => setV(r.data)).catch(fehler); }, [code]);
  if (!v) return null;
  return (
    <div className="pl-4 pb-2 space-y-0.5" data-testid={`versionen-${code}`}>
      {v.length === 0 ? <p className="text-xs text-[#8E7B71]">Noch keine Freigabe im CRM dokumentiert.</p> : v.map((x, i) => (
        <p key={i} className="text-xs text-[#78716c]">{x.version} (vorher {x.vorherige_version || "–"}) · freigegeben {dt(x.freigegeben_am)} von {x.freigegeben_von} · gültig bis {de(x.gueltig_bis)} · {x.aenderung}</p>
      ))}
    </div>
  );
};

export const QMDokumente = () => {
  const { user } = useAuth();
  const [liste, setListe] = useState([]);
  const [filter, setFilter] = useState("alle");
  const [auf, setAuf] = useState(null);
  const laden = useCallback(() => axios.get(`${API}/dokumente`).then((r) => setListe(r.data)).catch(fehler), []);
  useEffect(() => { laden(); }, [laden]);
  const freigeben = (d) => {
    const version = window.prompt(`Neue Version für ${d.code} (bisher ${d.version}):`, d.version);
    if (!version) return;
    const aenderung = window.prompt("Was wurde geändert? (für den Versionsverlauf)");
    if (!aenderung) return;
    const gueltig_bis = window.prompt("Gültig bis (JJJJ-MM-TT):", `${new Date().getFullYear() + 1}-12-31`);
    if (!gueltig_bis) return;
    axios.post(`${API}/dokumente/${d.code}/freigabe`, { version, aenderung, gueltig_bis }).then(() => { toast.success(`${d.code} freigegeben`); laden(); setAuf(d.code); }).catch(fehler);
  };
  const zahl = (s) => liste.filter((d) => d.freigabe_status === s).length;
  const sichtbar = liste.filter((d) => filter === "alle" || d.freigabe_status === filter);
  return (
    <div className="space-y-3" data-testid="qm-dokumente">
      <div className="flex flex-wrap gap-2">
        {["alle", ...Object.keys(STATUS)].map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`rounded-full px-3 py-1 text-xs ${filter === s ? "bg-[#3D3835] text-white" : "bg-white border"}`} data-testid={`dok-filter-${s}`}>
            {s === "alle" ? `alle (${liste.length})` : `${STATUS[s][0]} (${zahl(s)})`}
          </button>
        ))}
      </div>
      <div className="bg-white rounded-xl border border-[#F0E6DC] divide-y divide-[#F6E3DA]">
        {sichtbar.map((d) => (
          <div key={d.code}>
            <div className="p-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm" data-testid={`dok-${d.code}`}>
              <button className="font-mono text-xs underline" onClick={() => setAuf(auf === d.code ? null : d.code)}>{d.code}</button>
              <span className="font-medium min-w-[200px]">{d.name}</span><span>{d.version}</span>
              <span className="text-xs text-[#78716c]">{d.freigegeben_am ? `freigegeben ${de(d.freigegeben_am)} · gültig bis ${de(d.gueltig_bis)}` : `Stand ${d.datum || "–"}`}</span>
              <span className="ml-auto flex items-center gap-2">
                <Badge ton={STATUS[d.freigabe_status][1]} testid={`dok-status-${d.code}`}>{STATUS[d.freigabe_status][0]}</Badge>
                {user?.role === "gf" && <Button size="sm" variant="outline" onClick={() => freigeben(d)} data-testid={`dok-freigeben-${d.code}`}>Freigeben</Button>}
              </span>
            </div>
            {auf === d.code && <Versionen code={d.code} />}
          </div>
        ))}
      </div>
    </div>
  );
};
